import React from 'react';
import ScheduleDisplay from '../components/ScheduleDisplay';
import PriceScreen from '../components/PriceScreen';
import PriceScreenCenter from '../components/PriceScreenCenter';
import Edifice511Data from '../content/edifice-511.json';
import AutoRefresh from '../components/AutoRefreshProps';

export function EventPage511() {
  return (
    <div
      style={{
        position: 'relative',
        height: '100vh',
        display: 'flex',
        background: 'linear-gradient(to left, #001C4C 50%, transparent 50%)'
      }}
    >
      <div style={{
        left: '2.5rem',
        position: 'absolute',
        zIndex: 10,
        top: '2.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem'
      }}>
        <img src={"/feq.png"} alt={"FEQ"} className={"h-[3vw] w-fit"} />
        <p className={'text-[3vw]'} style={{
          fontWeight: 'bold',
          lineHeight: 1,
          color: "white",
        }}>
          Farruko
        </p>
        <p className={'text-[1vw]'} style={{
          fontWeight: 500,
          lineHeight: 1,
          textTransform: 'uppercase',
          color: "white",
        }}>13 Juillet</p>
      </div>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 10,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to left, #001C4C 40%, transparent 70%)'
      }}>
      </div>
      <div style={{
        position: 'relative',
        width: '66.666667%',
        height: '100%'
      }}>
        <img src={"/july13.png"} alt={"Rod Stewart"} style={{ objectFit: 'cover', position: "absolute", width: "100%", height: "100%" }} />
      </div>
      <div style={{
        width: '33.333333%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        marginRight: '2.5rem',
        zIndex: 20
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
        }}>
          <p className={'text-[3vw] leading-none'} style={{
            fontWeight: 500,
            color: "white",
          }}>
            Tarif Évènement<br/>
            Payable à la sortie:
          </p>
          <p className={'text-[1.5vw] leading-none'} style={{
            fontWeight: 500,
            color: "white",
          }}>
            Event price
          </p>
          <h1 className={'text-[10vw]'} style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}>
                        <span style={{
                          lineHeight: 1,
                          fontWeight: 'bold',
                          color: "white",
                        }}>20</span>
            <span className={'text-[6vw]'} style={{
              fontWeight: 'bold',
              lineHeight: 1.25,
              color: "white",
            }}>
                            $
                        </span>
          </h1>
          <p className={'text-[3vw] mt-3'} style={{
            fontWeight: 500,
            color: "white",
          }}>
            Bonne soirée !
          </p>
        </div>
      </div>
    </div>
  )
}

function Edifice511() {
  const dayContent = (
    <PriceScreen
      title={Edifice511Data.day.title}
      lines={Edifice511Data.day.lines}
    />
  );

  const nightContent = (
    <PriceScreenCenter
      title={Edifice511Data.night.title}
      lines={Edifice511Data.night.lines}
    />
  );
  /* function dayContent() {
    return (
      <PriceScreen
        title={Edifice511Data.day.title}
        lines={Edifice511Data.day.lines}
      />
    );
  }
  function ads1() {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <img
          src={ads2Img}
          alt="Pub test"
          className="h-full w-full object-cover"
        />
      </div>
    );
  }

  function dayContent2() {
    return (
      <PriceScreen
        title={Edifice511Data.day.title}
        lines={Edifice511Data.day.lines}
      />
    );
  }
  function ads2() {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <img
          src={ads1Img}
          alt="Pub test"
          className="h-full w-full object-cover"
        />
      </div>
    );
  }

  const screens = [dayContent, ads1, dayContent2, ads2]; */

  return (
    <div>
      <AutoRefresh intervalms={900000} /> {/* 15 min */}
      <ScheduleDisplay
        dayContent={dayContent}
        nightContent={nightContent}
        dayStartTime="00:00:00"
        nightStartTime="16:00:00" // 16:00:00
      />
      {/* <RotatingComponents screens={screens} interval={3000} /> */}
    </div>
  );
}

export default Edifice511;
